(function($) {

  var CTRL = new ScrollMagic.Controller();

  function menuToggle() {
    var $toggle = $('#responsive-toggle, #search-icon, .toggle-search')
    var $menu = $('#overlay-navigation')
    var $elements = $('#overlay-navigation ul li')
    var $search = $('#overlay-navigation .search-form-wrapper')

    var tL = new TimelineMax({paused:true})

    tL.staggerFrom($elements, 1, {y:-30, opacity: 0, ease:Power4.easeOut}, 0.2)
      .staggerFrom($search, 1, {y:20, opacity: 0, ease:Power4.easeOut}, 0.2, '-=1');

    $toggle.on('click', function() {
      //console.log(tL.totalDuration())
      var d = tL.totalDuration()
      var dm = d * 1000

      if (!$(this).hasClass('animating')) {
        $(this).toggleClass('active')

        if($menu.hasClass('open')) {
          tL.reverse()
          setTimeout(function(){
            $menu.slideUp(300).removeClass('open')
          }, dm)
        } else {
          $menu.addClass('open').slideDown(500)
          setTimeout(function(){
            tL.restart()
          }, 500)
        }
      }

      $(this).addClass('animating')

      setTimeout(function(){
        $toggle.removeClass('animating')
      }, dm)
    })

    $(window).on('resize', function(){

    })
  }

  function removeSlideshow() {
    var $loader = $('#loader')
    var $line = $('#loader .line')
    var splittedText = '.home #full-width-slideshow article header h2'
    var $bkImage = $('#loader .loader-background')
    var $loaderLogo = $('#loader .loader-logo')

    var tLoader = new TimelineMax({
      onComplete: function() {
        $('html, body').removeAttr('style')
      }
    })

    if (typeof TimelineMax == 'function') {
      $('body').addClass('tween')

      if($(document).scrollTop() === 0) $('html, body').css({'overflow': 'hidden', 'height': '100%'})

      var st = new SplitText(splittedText, {
        type: "lines",
        linesClass: "text-line"
      })

      tLoader.staggerTo($bkImage, 3.5, {
        opacity: 1,
        rotation: 0
      }).staggerTo($loaderLogo, 3.5, {
        scale: .90,
        opacity: 1
      }, '0', '-=3.5' ).staggerTo($loader, 2,{
        opacity: 0,
        display: 'none'
      }, '0', '-=1.5')
      .add(introHome, tLoader.duration()/3 )
      //console.log(tLoader.duration(), tLoader.duration()/3)
    }

  }

  function introHome() {
    console.log('Finish')
    var t = new TimelineMax({ paused: true})
    var $menuItems = $('#site-navigation #primary-menu > li, #search-icon')
    var $textLine = $('#full-width-slideshow article header h2 .text-line')
    var $image = $('#full-width-slideshow article img')
    var $logo = $('.primary-brand')
    var $symbol = $('#masthead .symbol-logo')

    t.staggerTo($image, 4, {scale: 1.15})
    .staggerTo($logo, 1.2, {opacity: 1, scale: 1}, "0.3", "-=2.2")
    .to($symbol, 3.2, {y:0, opacity: 0.5}, "-=2.2")
    .staggerTo($menuItems, 1, {y:0, opacity: 1, ease:Power2.easeOut}, "0.07", "-=2.2")
    .staggerTo($textLine, 1.2, {y:0, opacity: 1}, "0.3", "-=1.2")


    t.play()
  }

  function introPageHeader() {
    $('#page-loader').fadeOut(300)
    var tL = new TimelineMax({ delay: 0.9})
    var $menuItems = $('#site-navigation #primary-menu > li, #search-icon')
    var $textLine = $('#full-width-slideshow article header h2 .text-line')
    var $image = $('#full-width-slideshow article img')
    var $textLine = $('#masthead .entry-title')
    var $logo = $('.primary-brand')
    var $symbol = $('#masthead .symbol-logo')
    var $main = $('#main')
  //  var $masterhead = $('#masthead')

    tL.staggerFrom($logo, 1.2, {autoAlpha: 0}, "0.3", "-=0.9")
      .staggerFrom($symbol, 1.2, {y:0, autoAlpha: 0}, "0.3", "-=0.9")
      .staggerFrom($menuItems, 1.2, {y:-30, autoAlpha: 0, ease:Power2.easeOut}, "0.07", "-=0.9")
      .staggerFrom($textLine, 1.2, {y:0, autoAlpha: 0}, "0.3", "-=1.2")
      .from($main, 0.6, {y:0, autoAlpha: 0}, "-=0.9")

  }

  function scrollOurWork() {
    var tL = new TimelineMax()

    var $section = $('.home #our-works')
    var $title = $('.home #our-works .section-title')
    var $txt = $('.home #our-works > div > .entry-content')
    var $tile = $('.home #our-works .tile')


    tL.staggerFrom($section, 1, {opacity: 0}, "0", "-=1")
      .staggerFrom($title, 1.5, {y: -30, opacity: 0}, "0", "-=1")
      .staggerFrom($txt, 1.5, {y: -30, opacity: 0}, "0", "-=1")
      .staggerFrom($tile, 2, {opacity: 0, y:-10}, "0.5", "-=1.5")

    var scene = new ScrollMagic.Scene({
      triggerElement: '#our-works',
      reverse: true,
      triggerHook: 'onEnter',
      offset: 150
    })
    scene.setTween(tL)
    scene.addTo(CTRL)
  }


  function scrollHowDo() {
    var tL = new TimelineMax()

    var $section = $('.home #how-do')
    var $title = $('.home #how-do .section-title')
    var $txt = $('.home #how-do > div > .entry-content')
    var $cta = $('.home #how-do a.button')

    tL.staggerFrom($section, 3, {opacity: 0}, "0", "0")
      .staggerFrom($title, 1.5, {y: 30, opacity: 0}, "0", "-=3")
      .staggerFrom($txt, 1.5, {y: 30, opacity: 0}, "0", "-=2")
      .staggerFrom($cta, 1, {opacity: 0}, "0.5", "-=0.5")

    var scene = new ScrollMagic.Scene({
      triggerElement: '#how-do',
      reverse: true,
      triggerHook: 'onEnter',
      offset: 100
    })
    scene.setTween(tL)
    scene.addTo(CTRL)
  }

  function scrollSlideShow() {
    var tL = new TimelineMax()

    var $textLine = $('#full-width-slideshow article header h2 .text-line')

    tL.staggerFrom($textLine, 2, {opacity: 0, y: -30}, "0", "0")

    var scene = new ScrollMagic.Scene({
      triggerElement: '.home #full-width-slideshow',
      reverse: true,
      triggerHook: 'onEnter',
      offset: 200
    })
    scene.setTween(tL)
    scene.addTo(CTRL)
  }

  function introSection() {
    $("section .inner").each(function(i, val) {
      $this = $(val);
      //$items = $this.find('header .section-title, .entry-content, .button');
      var tl = new TimelineMax({delay: "0.3"})
          .staggerFrom($this.find('.list-categories, .section-title, .entry-content'), 1.2, {y:45, autoAlpha:0, ease:Power2.easeOut}, "0.15", "0")
          .from($this.find('.button'), .9, {autoAlpha:0, ease:Power2.easeOut}, "-=.3")

          var scene = new ScrollMagic.Scene({
            triggerElement: val,
            triggerHook: 'onEnter',
            reverse: true,
            offset: 120
          })
          .setTween(tl)
          .addTo(CTRL);
        });

        $("section").each(function(i, val) {
          $this = $(val);
          //$items = $this.find('.tile, .tile header, .tile .entry-content, .tile button');
          var tl = new TimelineMax({delay: "0.3"})
          .staggerFrom($this.find('.tile img'), 1.2, {y:0, autoAlpha:0, ease:Power2.easeOut}, "0.15", "-=0.3")
          .staggerFrom($this.find('.tile'), 1.2, {y:45, autoAlpha:0, ease:Power2.easeOut}, "0.15", "0")
          .staggerFrom($this.find('.tile header, .tile .entry-content'), .9, {y:15, autoAlpha:0, ease:Power2.easeOut}, "0.15", "-=0.6")
          .staggerFrom($this.find('.tile .button'), .9, {x:0, autoAlpha:0, ease:Power2.easeOut}, "0.1", "-=0.3")

          var scene = new ScrollMagic.Scene({
            triggerElement: val,
            triggerHook: 'onEnter',
            reverse: true,
            offset: 120
          })
          .setTween(tl)
          .addTo(CTRL);
        });

    $("section#latest-news .masonry-grid-element").each(function(i, val) {
      $this = $(val);
      //$items = $this.find('.tile, .tile header, .tile .entry-content, .tile button');
      var scene = new ScrollMagic.Scene({
        triggerElement: val,
        triggerHook: 'onEnter',
        reverse: true,
        offset: 0
      })
      .setTween(
        TweenMax.staggerFrom($this, 0.9, {
          delay: 0.3,
          alpha: 0,
          y: 45
        }, 0.20)
      )
      .addTo(CTRL);
    });
  }

  $(document).ready(function(){
    //introHome('#full-width-slideshow article header', '#full-width-slideshow .scroll-down-arrow')
    //menuToggle()
    //introSection()
    //introPage()
    //removeSlideshow()
    //scrollOurWork()
    //scrollHowDo()
  });

  var incode_starter = {
    'common': {
      init: function() {
        menuToggle()
      }
    },
    'home': {
      init: function() {
        introSection()
        removeSlideshow()
      }
    },
    'page': {
      init: function() {
        if(!$('body').hasClass('home')) {
          introPageHeader()
        }

      }
    },
    'single': {
      init: function() {
        if(!$('body').hasClass('home')) {
          introPageHeader()
        }
      }
    },
      'single': {
      init: function() {
        if(!$('body').hasClass('home')) {
          introPageHeader()
        }
      }
    }
  };

  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = incode_starter;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      UTIL.fire('common');

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      UTIL.fire('common', 'finalize');
    }
  };

  $(document).ready(UTIL.loadEvents);



})(jQuery);
